export const LinkTypes = {
  PAGE: "page",
  LINK: "direct",
  EMAIL: "email",
};

export const SOURCES_OPTIONS = [
  {
    value: LinkTypes.PAGE,
    label: "Confluence page",
  },
  {
    value: LinkTypes.LINK,
    label: "Direct link",
  },
  {
    value: LinkTypes.EMAIL,
    label: "Email address",
  },
];
